import mirror from 'mirror-to-object-pairs';

export const screens = mirror([
  // Screens
  'Initial',
  'SignIn',
  'SignUp',
  'MyMusic',
  'Search',
  'SearchTutorial',
  'SearchTrack',
  'SearchProfile',
  'Hub',
  'Profile',
  'Onboarding',
  'SuccessfulSignIn',
  'ForgotPassword',
  'SetNewPassword',
  'SkillLevelQuestionnaire',
  'Questionnaire',
  'UsersSuggestion',
  'InviteSuggestion',
  'UpdateProfilePrivate',
  'UpdateProfileGeneral',
  'Filters',
  'Security',
  'UpdatePassword',
  'Settings',
  'Notifications',
  'MyHub',
  'Subscription',
  'Language',
  'InviteFriend',
  'Help',
  'ContactUs',
  'About',
  'FormPicker',
  'Tutorial',
  'Track',
  'Tutorials',
  'LatestTracks',
  'PopularTracks',
  'News',
  'Latest',
  'Followers',
  'Following',
  'UserNews',
  'UserTracks',
  'ChooseSubscriptionPlan',
  'AddPaymentMethod',
  'CreditCards',
  'UpdateCreditCard',
  'ChangeSubscriptionPlan',
  'Payment',
  'FindFriend',
  'PostEditor',
  'Chats',
  'ChatsSearch',
  'Messaging',
  'Gallery',
  'Report',
  'Referral',
  'Comment',
  'Likes',
  'TrackFeedback',
  'TrackFeedbackForm',
  'CreditsPayment',
  'AddPaymentMethodConfirm',
  'PaymentConfirm',
  'CourseSummary',
  'Courses',

  // Navigators
  'SwitchNavigator',
  'AuthNavigator',
  'MainNavigator',
  'SearchNavigator',
  'TabNavigator',
  'PersonalizationNavigator',
  'ProfileNavigator',
  'HubNavigator',
  'MusicNavigator',
  'ChatNavigator',
  'HomeTabNavigator',
  'UserProfileTabNavigator',
  'SearchTabNavigator',
  'PostNavigator',
  'FeedbackNavigator',
]);

export type ScreensType = typeof screens;
export type ScreensNameType = keyof ScreensType;
